import { PortalDialogProps } from "@app/services/modal.service";
import Modal from "../modal/modal.component";
// import { ImageItem } from "@app/types";
import { Images } from "@assets/images";
import useBusy from "@core/hooks/use-busy.hook";
import { Spinner } from "../ui";
import PlayPcrenderService from "@app/services/http/play.pcrender.service";
import { useState } from "react";
import { addToast } from "../toast/toast.service";
import { ImageCloud, ImageItem } from "@app/types";
import { MAX_LEN } from "@app/constants";
import { IcCopy, IcFileText, IcKeyRound, IcMonitor, IcX } from "../icons";

function PlayPcrenderModal({ portalDialogRef, portalData }: PortalDialogProps) {
  // const image: ImageItem = portalData;
  const image = portalData?.image as ImageItem;
  const imageCloud = portalData?.imageCloud as ImageCloud;

  // nút vừa bấm xoay, không che cả trang
  const { busy, run } = useBusy();
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  if (!image && !imageCloud) {
    portalDialogRef.close();

    return null;
  }

  const image_id = image?._id || imageCloud?._id;

  const [token, setToken] = useState<string | null>(
    image?.token_pc || imageCloud?.token_pc
  );

  const onPlayPcrender = (action: string) => {
    switch (action) {
      case "win":
      case "mac_chip_apple_silicon":
      case "mac_chip_intel":
        if (image) {
          run(
            action,
            () => PlayPcrenderService.getDownloadLinkForPc(image_id, action),
            (res) => {
              window.open(res.link, "_blank");
            }
          );
        } else if (imageCloud) {
          run(
            action,
            () => PlayPcrenderService.getDownloadLinkForCloud(image_id, action),
            (res) => {
              window.open(res.link, "_blank");
            }
          );
        }

        break;
      case "token":
        if (image) {
          run(
            action,
            () => PlayPcrenderService.getTokenForPc(image_id, username, password),
            (res) => {
              setToken(res.token);
              addToast({ text: "Lấy token thành công" });
            }
          );
        } else if (imageCloud) {
          run(
            action,
            () => PlayPcrenderService.getTokenForCloud(image_id, username, password),
            (res) => {
              setToken(res.token);
              addToast({ text: "Lấy token thành công" });
            }
          );
        }

        break;
    }
  };

  const handleClose = () => {
    portalDialogRef.close({ token });
  };

  const downloadButton =
    "flex flex-col items-center justify-center gap-1.5 rounded-xl border border-brand-line bg-brand-soft px-3 py-4 text-[14px] font-semibold text-brand transition-colors hover:bg-brand hover:text-white";

  return (
    <Modal onCancel={handleClose} buttonCancelInChildren={false}>
      <div className="flex w-[min(560px,calc(100vw-32px))] flex-col text-fg">
        <div className="flex items-start justify-between gap-3 border-b border-line px-6 pb-4 pt-5">
          <div>
            <h2 className="text-[19px] font-bold">PCRender Play</h2>
            <p className="m-0 mt-0.5 text-[13px] text-muted">{image?.name || imageCloud?.name}</p>
          </div>
          <button
            type="button"
            aria-label="Đóng"
            className="grid h-8 w-8 place-items-center rounded-lg border border-line bg-surface text-fg hover:bg-surface-2"
            onClick={handleClose}
          >
            <IcX className="h-4 w-4" />
          </button>
        </div>

        <div className="flex flex-col gap-3 px-6 py-5">
          <button
            type="button"
            className="flex items-center justify-center gap-3 rounded-xl bg-brand px-4 py-4 text-[16px] font-bold text-brand-ink transition-colors hover:bg-brand-hover"
            disabled={busy.win}
            onClick={() => onPlayPcrender("win")}
          >
            {busy.win ? <Spinner className="h-6 w-6" /> : <img className="h-7 w-7" src={Images.Window.default} alt="" />}
            Download Windows Installer
          </button>
          <div className="grid grid-cols-2 gap-3">
            <button type="button" className={downloadButton} disabled={busy.mac_chip_apple_silicon} onClick={() => onPlayPcrender("mac_chip_apple_silicon")}>
              {busy.mac_chip_apple_silicon ? <Spinner className="h-6 w-6" /> : <IcMonitor className="h-6 w-6" />}
              MacOS chip Apple Silicon
            </button>
            <button type="button" className={downloadButton} disabled={busy.mac_chip_intel} onClick={() => onPlayPcrender("mac_chip_intel")}>
              {busy.mac_chip_intel ? <Spinner className="h-6 w-6" /> : <IcMonitor className="h-6 w-6" />}
              MacOS chip Intel
            </button>
          </div>

          {/* Chỉ hiện khi đã có token, như bản cũ */}
          {token && (
            <>
              <div className="flex items-start gap-3 rounded-xl bg-surface-2 px-4 py-3 text-[14px] leading-relaxed text-muted">
                <div className="min-w-0 flex-1">
                  Để tăng cường bảo mật cho máy thuê, bạn có thể nhập <b className="text-fg">Username</b> và{" "}
                  <b className="text-fg">Password</b>. Hai thông tin này lấy từ máy thuê, ở màn hình desktop, trong
                  ứng dụng:
                  <div className="my-1 flex items-center gap-2 font-mono text-[13px] text-fg">
                    <IcFileText className="h-4 w-4 flex-none" />
                    Change_Password_Play_Pcrender_Desktop
                  </div>
                  <div className="font-medium text-bad">Nhập xong bấm “Lấy Token” để thay đổi thông tin Token.</div>
                </div>
                <img
                  src={Images.FileUserPassPlayPcrender.default}
                  alt=""
                  className="w-[72px] flex-none rounded-md max-[480px]:hidden"
                />
              </div>
              <div className="grid grid-cols-2 gap-3 max-[480px]:grid-cols-1">
                <label className="flex flex-col gap-1 text-[13px] font-semibold text-muted">
                  Username
                  <input
                    className="h-11 rounded-[10px] border border-line bg-surface px-3 text-fg outline-none focus:border-brand"
                    placeholder="Username"
                    maxLength={MAX_LEN.CREDENTIAL}
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                  />
                </label>
                <label className="flex flex-col gap-1 text-[13px] font-semibold text-muted">
                  Password
                  <input
                    className="h-11 rounded-[10px] border border-line bg-surface px-3 text-fg outline-none focus:border-brand"
                    placeholder="Password"
                    maxLength={MAX_LEN.CREDENTIAL}
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                  />
                </label>
              </div>
            </>
          )}

          <div className="grid grid-cols-[auto_minmax(0,1fr)_auto] items-center gap-2.5 max-[560px]:grid-cols-2">
            <button
              type="button"
              className="inline-flex h-11 items-center justify-center gap-2 rounded-[10px] bg-brand px-4 font-semibold text-brand-ink hover:bg-brand-hover"
              disabled={busy.token}
              onClick={() => onPlayPcrender("token")}
            >
              {busy.token ? <Spinner /> : <IcKeyRound className="h-[18px] w-[18px]" />}
              Lấy Token
            </button>
            <input
              readOnly
              type="text"
              value={token ?? ""}
              className="h-11 min-w-0 rounded-[10px] border border-line bg-surface px-3 text-center font-mono max-[560px]:col-span-2 max-[560px]:row-start-1 text-[16px] font-semibold tracking-[.06em] text-fg outline-none"
            />
            {token && (
              <button
                type="button"
                className="inline-flex h-11 items-center gap-2 rounded-[10px] border border-line bg-surface px-4 font-semibold text-fg hover:bg-surface-2 max-[560px]:justify-center"
                onClick={() => {
                  navigator.clipboard.writeText(token ?? "");
                  addToast({ text: "Đã sao chép vào bộ nhớ tạm" });
                }}
              >
                <IcCopy className="h-[18px] w-[18px]" />
                Sao chép
              </button>
            )}
          </div>

          <a
            className="text-center font-semibold text-brand underline"
            href="https://pcrender.vn/huong-dan-su-dung-phan-mem-play-pcrender-de-choi-game-fps"
            target="_blank"
            rel="noreferrer"
          >
            Hướng dẫn sử dụng
          </a>
        </div>
      </div>
    </Modal>
  );
}

export default PlayPcrenderModal;
